import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import LoadingSpinner from "../../components/LoadingSpinner";
import When from "../../components/When";

export const DashboardCardContentStatistics = ({
                                                   valueAsString,
                                                   title,
                                                   loading = false,
                                               }: { valueAsString: string, title: string, loading?: boolean }) => (
    <>
        <Row style={{height: "70%"}}>
            <Col className="dashboard-card-content-wrapper">
                <span className="dashboard-card-content-text">
                    <When condition={!loading} otherwise={<LoadingSpinner/>}>
                        {valueAsString}
                    </When>
                 </span>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <span className="dashboard-card-title">
                    {title}
                </span>
            </Col>
        </Row>
    </>
);


export const DashboardCardContentImage = ({
                                              image,
                                              title
                                          }: { image: any, title: string }) => (
    <>
        <Row style={{height: "70%"}}>
            <Col className="dashboard-card-content-wrapper">
                {image}
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <span className="dashboard-card-title">
                    {title}
                </span>
            </Col>
        </Row>
    </>
);

export const DashboardCardContentDetails = () => (
    <>
        <Row>
            <Col>
                <h4 className="text-center">Mina Uppgifter</h4>
            </Col>
        </Row>
        <Row>
            <Col>
                <ul>
                    <li>Vet ej hur</li>
                    <li>Detta ska funka</li>
                </ul>
            </Col>
        </Row>
    </>
)